import axios from 'axios'
// import VueCookies from 'vue-cookies'

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json',
  },
  timeout: 10000 //Throw error if API call takes longer than 10 sec//
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.authorization = 'Bearer '+ token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);


export default {
  shipOrder(cartId, shippingData) {
    return apiClient.post(`/shipping/${cartId}`, shippingData)
  },
  getShippingRates(cartId) {
    return apiClient.get(`/shipping/${cartId}/rates`)
  },
  getShippingKey() {
    return apiClient.get(`/shipping/platform/key`)
  },
  postShippingKey(keyJson) {
    return apiClient.post(`/shipping/platform/key`, keyJson)
  },
  getValidateAddress(addressJson) {
    return apiClient.get(`/address/validate`, { params: addressJson})
  }
}
